import { gql } from '@apollo/client'

export const GET_RECOMMENDED_UP_NEXT = gql`
  query getRecommendedUpNext($titleId: String!) {
    recommendedUpNextV3(titleId: $titleId) {
      content {
        id
        attribution
        title {
          ... on ContentSeries {
            id
            project {
              id
              slug
            }
          }
          ... on ContentMovie {
            id
            project {
              id
              slug
            }
          }
          ... on ContentSpecial {
            id
            project {
              id
              slug
            }
          }
          ... on ContentDisplayable {
            id
            name
            image(aspect: "16:9", category: ANGEL_KEY_ART_1) {
              cloudinaryPath
            }
          }
        }
        watchable {
          ... on Node {
            id
          }
          ... on ContentWatchableAvailability {
            watchableAt
            watchableAvailabilityStatus
          }
        }
      }
    }
  }
`

export const GET_SUGGESTED_SHOWS_AND_FILMS = gql`
  query getSuggestedShowsAndFilms($titleId: String!) {
    relatedTitlesV2(titleId: $titleId) {
      content {
        id
        attribution
        title {
          ... on ContentSeries {
            id
            project {
              id
              slug
              highestScore
            }
          }
          ... on ContentMovie {
            id
            project {
              id
              slug
              highestScore
            }
          }
          ... on ContentSpecial {
            id
            project {
              id
              slug
              highestScore
            }
          }
          ... on ContentDisplayable {
            id
            name
            image(aspect: "2:3", category: ANGEL_KEY_ART_1) {
              cloudinaryPath
            }
          }
        }
        watchable {
          ... on Node {
            id
          }
          ... on ContentWatchableAvailability {
            watchableAt
            watchableAvailabilityStatus
          }
        }
      }
    }
  }
`
